const StayReceivedThesis = {
  tableConfig: {
    showCheckbox: true,
    comment: '全委托送审与半委托送审管理费和专家费由平台打款，自助送审打款由送审单位与专家线下自行协商。'
  },
  queryList: [
    {
      name: 'unitName',
      label: '送审单位',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    }
  ],
  urlMap: {
    'select': {
      url: '/school/schoolDegreeOffice/getWaitReceivePaperInfo',
      data: {
        acceptStatus: '2'
      }
    },
    'recieveSelect': '/school/schoolDegreeOffice/receiveOrRejectReviewSelect',
    'recieveAll': '/school/schoolDegreeOffice/receiveOrRejectReviewAll',
    'delayAll': '/school/schoolDegreeOffice/receiveOrRejectReviewAll'
  },
  operList: [// 操作列表
    {
      name: 'chooseReview',
      label: '选中接收',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '{expReviewIds:("{tableSelectionIds}").split(","),unitReceiveState:"3"}',
        addr: '/school/schoolDegreeOffice/receiveOrRejectReviewSelect'
      }
    },
    {
      name: 'recieveAll',
      label: '全部接收',
      show: true,
      action: {
        type: 'request',
        addr: 'recieveAll',
        data: {unitReceiveState: '3'}
      }
    },
    {
      name: 'chooseDelay',
      label: '选中退回',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '{expReviewIds:("{tableSelectionIds}").split(","),unitReceiveState:"4"}',
        addr: '/school/schoolDegreeOffice/receiveOrRejectReviewSelect'
      }
    },
    {
      name: 'delayAll',
      label: '全部退回',
      show: true,
      action: {
        type: 'request',
        addr: 'delayAll',
        data: {unitReceiveState: '4'}
      }
    }
  ],
  titles: [
    {
      name: 'expReviewId',
      key: true
    },
    {
      name: 'sendType',
      label: '送审方式'
    },
    {
      name: 'unitName',
      label: '送审单位'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'researchAera',
      label: '论文涉及的研究方向',
      width: 160
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'arrangeTime',
      label: '发送时间'
    },
    {
      name: 'batchName',
      label: '批次号'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '接收',
          kind: 'primary',
          type: 'request',
          data: {
            expReviewIds: ['{expReviewId}'],
            unitReceiveState: '3'
          },
          addr: '/school/schoolDegreeOffice/receiveOrRejectReviewSelect'
        },
        {
          label: '退回',
          kind: 'primary',
          type: 'request',
          data: {
            expReviewIds: ['{expReviewId}'],
            unitReceiveState: '4'
          },
          addr: '/school/schoolDegreeOffice/receiveOrRejectReviewSelect'
        }
      ]
    }
  ]
}
export default StayReceivedThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/stayReceivedThesis.js